export default "__VITE_ASSET__cf4c723e__"